module.exports = __webpack_public_path__ + "static/media/image4.0ec684be.jpg";